// extracted by mini-css-extract-plugin
export default {"root":"AuthPage_root__PEk3x","backgroundContainer":"AuthPage_backgroundContainer__fVTN3","header":"AuthPage_header__cLppQ"};